import { getOmnistore } from '../stores/Omnistore';
import { Communicator } from './Communicator';
export * from './Communicator';

export const commSvc = new Communicator(() => getOmnistore().reoctoStore, () => getOmnistore().authStore);
